export default class OnlineContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "FindPlayer";
  }

  async show(path) {
    const app = this.app;
    const pageId = this.pageId;

    let model = this.getModel();
    app.populate(pageId, model);
    app.swapPage(pageId);

    //update fb friend in background, then update model
    //only update once per session
    if (this.friendsUpdated) return;
    this.friendsUpdated = true;
    await this.updateFBFriend();
    await this.updateFriends();
    model = this.getModel();
    app.populate(pageId, model);

  }
  getModel() {
    const app = this.app;
    const userdata = app.userdata;


    if (!userdata.friends) userdata.friends = [];
    if (!userdata.blockedPlayers) userdata.blockedPlayers = [];
    let friends = userdata.friends;
    let blockedPlayers = userdata.blockedPlayers.length + "";
    let isOnFacebook = app.platform === 'facebook';
    let model = {
      friends: friends,
      isOnFacebook: isOnFacebook,
      blockedPlayers: blockedPlayers,
      id: userdata.id
    }
    return model;
  }
  async updateFriends() {

    const app = this.app;
    const userdata = app.userdata;
    const friends = userdata.friends;
    if (!friends) return;
    for (let i = 0; i < friends.length; i++) {
      let friend = friends[i];
      let user = null;
      // get by userid
      try {
        user = await app.accountJD.GetUser(friend.id);
      } catch (e) {
        console.warn("updateFriends GetUser error:" + e.message);
      }
      //try facebookid
      if (!user && friend.facebookId) {
        try {
          user = await app.accountJD.FindUser(friend.facebookId);
        } catch (e) {
          console.warn("updateFriends FindUser error:" + e.message);
        }
      }
      if (user) {
        friend.id = user.id;
        friend.name = user.name;
        friend.avatar = user.avatar;
        friend.facebookId = user.facebookId;
      }
    }

  }

  //facebook zero permission - restricted getConnectedPlayersAsync to just facebookids
  async updateFBFriend() {
    const app = this.app;
    //this only uses facebook for now
    if (app.platform !== "FBInstant") return;

    //update friend count
    try {
      const friendsPortal = await app.portal.getFriends();
      if (!friendsPortal) return;
      for (let i = 0; i < friendsPortal.length; i++) {
        const fbUser = friendsPortal[i];

        const facebookId = fbUser.facebookId;
        if (!facebookId) continue;
        //Facebook only gaves the facebookid, no name or userid

        let friend = app.userdata.friends.find(f => f.facebookId === facebookId);
        if (friend) continue; //already added


        //try getting the user by facebookid from our database
        try {
          let user = await app.accountJD.FindUser(facebookId);
          if (user) {
            app.addFriend({
              id: user.id,
              avatar: user.avatar,
              name: user.name,
              facebookId: user.facebookId,
              trusted: true
            });
          }
        } catch (e) {
          console.warn("updateFBFriend FindUser error:" + e.message);
        }
      }
    } catch (e) {
      console.warn("updateFBFriend error:" + e.message);
    }
  }
  async inviteFb() {
    const app = this.app;
    const room = app.userdata.id + ""
    await app.portal.findAndInvite(app.userdata, room);
    app.joinCustomRoom(room);
  }
  async invitePlayer(toUserId, facebookId, isTrusted, room) {
    const app = this.app;
    if (!room) room = app.userdata && app.userdata.id + "";
    if (!room) room = Math.floor(Math.random() * Math.floor(100000000)) + "";
    let isInviteSent = false;
    const fromUserId = app.userdata && app.userdata.id;

    //Game socket invite
    if (app.gameServer) {
      try {
        console.log(`socketClient.invite userId:${toUserId}, room:${room}`)
        const response = await app.gameServer.invite(toUserId, room);
        app.createNotification(response);
        if (response === "Invite sent") {
          isInviteSent = true;
          //if online join the room and not send other invites
          app.joinCustomRoom(room);
          return;
        }
      } catch (e) {
        console.warn("invitePlayer socket invite error:", e.message);
      }
    }


    //facebook invite (if game socket invite failed or not online)
    if (facebookId && app.platform === "FBInstant") {
      try {
        const fbinviteSent = await app.portal.invite(facebookId, room);
        if (fbinviteSent) {
          console.log(`invitePlayer sentInviteFB:${fbinviteSent}`);
          isInviteSent = true;
        }
      } catch (e) {
        console.warn("invitePlayer facebook invite error:", e.message);
      }
    }

    //Push notification invite
    //trusted = invite by email or by number, not by recent games or in game
    if (isTrusted == true) {
      try {
        const sentPushNotification = await app.gamification.InviteSend(fromUserId, toUserId, room, null);
        if (sentPushNotification) {
          app.createNotification("Invite sent via Push Notification");
          isInviteSent = true;
        }
      } catch (e) {
        console.warn("invitePlayer push invite error:", e.message);
      }
    }

    if (isInviteSent) {
      app.joinCustomRoom(room);
    } else {
      console.log("No invite method available");
    }
  }
  clearblockPlayers() {
    const app = this.app;
    app.userdata.blockedPlayers = [];

    //update socket server data
    if (app.gameServer) app.gameServer.login(app.userdata);
    app.navigate('FindPlayer');
  }
  findPlayer(search) {
    const app = this.app;
    let value = parseInt(search, 10);

    //serach by Id
    if (value) {
      let id = value;
      this.findPlayerById(id);
    }
    //search by email
    if (!value) {
      let email = search;
      this.findPlayerByEmail(email);
    }
  }
  findPlayerById(id) {
    const app = this.app
    app.gamification.GetUser(id).then(function (user) {
      if (!user) {
        app.createNotification("No user found");
        return;
      }
      app.addFriend({
        id: user.Id,
        avatar: user.Avatar,
        name: user.Name,
        facebookId: user.FacebookId,
        trusted: true
      });
      app.navigate('FindPlayer');
    }.bind(this));
  }
  findPlayerByEmail(email) {
    const app = this.app
    app.gamification.FindUser(null, null, email).then(function (user) {
      if (!user) {
        app.createNotification("No user found");
        return;
      }
      app.addFriend({
        id: user.Id,
        avatar: user.Avatar,
        name: user.Name,
        facebookId: user.FacebookId,
        trusted: true
      });
      app.navigate('FindPlayer');
    }.bind(this));
  }
  addFriend(user) {
    const app = this.app;
    app.addFriend(user);
  }
  removeFriend(id) {
    const app = this.app
    let friends = app.userdata.friends;
    app.userdata.friends = friends.filter(function (obj) {
      return obj.id != id;
    });
    app.navigate('FindPlayer');
  }
}